"use client";

import { motion } from "framer-motion";
import Navbar from "@/app/components/Navbar";
import Footer from "@/app/components/Footer";

export default function PrivacyPage() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen px-6 py-32" style={{ background: "#0A0908" }}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl mx-auto"
        >
          <h1
            className="text-3xl md:text-4xl font-light mb-2"
            style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}
          >
            Privacy Policy
          </h1>
          <p
            className="text-xs mb-12"
            style={{ color: "rgba(245,240,232,0.3)", fontFamily: "'Montserrat', sans-serif" }}
          >
            Last updated: April 2024
          </p>

          <div className="space-y-8 text-sm leading-relaxed" style={{ color: "rgba(245,240,232,0.6)", fontFamily: "'Montserrat', sans-serif" }}>
            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Introduction
              </h2>
              <p>
                At Aurelius & Co, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our service.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Information We Collect
              </h2>
              <p className="mb-2">We collect the following types of information:</p>
              <ul className="space-y-2 pl-4">
                <li>• Account information (name, email) when you sign up</li>
                <li>• Instagram account data via OAuth (account ID, username)</li>
                <li>• Usage data (messages processed, automation triggers)</li>
                <li>• Technical data (IP address, browser type, device info)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                How We Use Your Information
              </h2>
              <p className="mb-2">We use your information to:</p>
              <ul className="space-y-2 pl-4">
                <li>• Provide and maintain our services</li>
                <li>• Process your Instagram DMs and comments</li>
                <li>• Improve and customize our service</li>
                <li>• Communicate with you about updates and support</li>
                <li>• Enforce our terms and prevent fraud</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Data Storage and Security
              </h2>
              <p>
                Your data is stored on secure servers. We implement industry-standard security measures including encryption, access controls, and regular security audits. Instagram access tokens are encrypted and stored securely.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Third-Party Disclosure
              </h2>
              <p>
                We do not sell, trade, or otherwise transfer your personal information to outside parties. We may share data with service providers who assist us in operating our platform (hosting, analytics, email delivery).
              </p>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Your Rights
              </h2>
              <p className="mb-2">You have the right to:</p>
              <ul className="space-y-2 pl-4">
                <li>• Access your personal data</li>
                <li>• Request data deletion</li>
                <li>• Export your data</li>
                <li>• Revoke Instagram access at any time</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Contact Us
              </h2>
              <p>
                If you have questions about this Privacy Policy, please contact us at support@aureliusco.com
              </p>
            </section>
          </div>
</motion.div>
      </main>
      <Footer />
    </>
  );
}